/**
 * Status shared by source documents, digitisation runs and enrichment runs.
 * Allowed moves are set in SQL: `public.is_processing_status_transition_allowed`
 * for runs, and `public.is_source_document_status_transition_allowed` for
 * documents, where a failed document goes back to pending, not processing.
 */
export enum ProcessingStatus {
  Pending = 'pending',
  Deferred = 'deferred',
  Processing = 'processing',
  Processed = 'processed',
  Failed = 'failed',
  Rejected = 'rejected',
}
